import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class BusinessOperate extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return content.map((item, index) => (
            <div key={index} className={styles.businessOperate}>
                <a href={item.picLink} className={styles.businessOperateLink}>
                    <img className={styles.businessOperateImg} src={item.picUrl} />
                </a>
            </div>
        ));
    }
}

export default errorBoundary(BusinessOperate);
